import React from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox, FormControlLabel, FormHelperText, FormGroup } from '@mui/material';
import { useGlobalStyles } from "./globalStyles.js";


const CheckboxFieldRHF = ({
  name,
  control,
  label,
  required = false,
  disabled = false,
}) => {
  const labelWithAsterisk = required ? `${label} *` : label;
    const classes = useGlobalStyles();


  return (
    <FormGroup>
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <FormControlLabel
              control={
                <Checkbox
                  {...field}
                  checked={!!field.value}
                  disabled={disabled}
                  onChange={(e) => field.onChange(e.target.checked)}
                  className={classes.customCheckbox}
                />
              }
              label={labelWithAsterisk}
            />
            {error && <FormHelperText error>{error.message}</FormHelperText>}
          </>
        )}
      />
    </FormGroup>
  );
};

export default CheckboxFieldRHF;